import React, { useEffect } from "react";
import Footer from "../components/footer";
import Review from "../components/aboutPage/Review";
import Gotop from "../components/gotop";
import Iconbox3 from "../components/aboutPage/Iconbox3";
import Testimonial from "../components/aboutPage/Testimonial";
import dataTestimonials from "../assets/fakeData/dataTestimonials";
import Partner from "../components/aboutPage/Partner";
import { useState } from "react";
import NonLoginHeader from "../components/header/NonLoginHeader";
import MobileHeader from "../components/header/MobileHeader";
import LoginMobileHeader from "../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../components/header/InstituteMobileHeader";
import CRMobileHeader from "../components/header/CRMobileHeader";
import LoginHeader from "../components/header/LoginHeader";
import InstituteHeader from "../components/header/InstituteHeader";
import CRHeader from "../components/header/CRHeader";
import WorkspacePremiumSharpIcon from '@mui/icons-material/WorkspacePremiumSharp';
import SchoolSharpIcon from '@mui/icons-material/SchoolSharp';
import SignalCellularAltSharpIcon from '@mui/icons-material/SignalCellularAltSharp';
import HourglassTopSharpIcon from '@mui/icons-material/HourglassTopSharp';
import { Helmet } from "react-helmet";

import { Link, useLocation } from "react-router-dom";
import img1 from "../assets/images/khojgraphics/Campus.png";
import img2 from "../assets/images/khojgraphics/Corporate.png";
import img3 from "../assets/images/khojgraphics/Talent.png";

AboutUs.propTypes = {};

function AboutUs() {
	const [isShowMobile, setShowMobile] = useState(false);
	const handleMobile = () => {
		const getMobile = document.querySelector(".menu-mobile-popup");
		setShowMobile(!isShowMobile);
		!isShowMobile
			? getMobile.classList.add("modal-menu--open")
			: getMobile.classList.remove("modal-menu--open");
	};
	const module = localStorage.getItem('Module')

	const location = useLocation();

	useEffect(() => {
		if (location.hash) {
			const element = document.getElementById(location.hash.substring(1));
			if (element) {
				element.scrollIntoView({ behavior: "smooth" });
			}
		}
	}, [location]);

	return (
		<>
			<Helmet>
				<title>About-Us | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="About-Us | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
			{module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
				module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
					module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
						module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
							<MobileHeader handleMobile={handleMobile} />}
			{module === 'Candidate' ? <LoginHeader handleMobile={handleMobile} /> :
				module === 'Institution' ? <InstituteHeader handleMobile={handleMobile} /> :
					module === 'Company' ? <CRHeader handleMobile={handleMobile} /> :
						module === 'Recruiter' ? <CRHeader handleMobile={handleMobile} /> :
							<NonLoginHeader handleMobile={handleMobile} />}

			<div className="pt-70" >
				<Review />
				{/* <BannerCounter /> */}
				<section id="Service" className="wd-iconbox style-3 inner-iconbox-section pt-3"  >
					<div className="container">
						<div className="title-iconbox style-3 stc">
							<h4>Rediscover your path with <span className="khoj-text-color">KHOJ</span></h4>
							{/* <h5 className="f-600 mb-2">
								Get started with our career support packages curated just for you
							</h5>
							<p className="f-20">We at Manzil don't see ourselves as service providers but as a bridge to your future. This is our way of giving back to the community that has supported us, a chance to share the expertise, the insights, and the connections we’ve built over years of hard work.</p> */}
						</div>
						<div className="row All-CICR-Class justify-content-center">
							<div className="col-lg-12"> 
							</div>

							<div className="tf-iconbox style-3 cl3 stc2 p-2 col-md-6 custom-works-card  text-center tf-iconbox-Rediscover">
								<div className="box-header">
									<div className="img1">
										<img src={img1} alt="img" className="mb-1" />
									</div>
								</div>
								<div className="box-content">
									<h6 className="box-title">
										{/* <Link to="/Blogsingle_v1">Candidates</Link> */}
									</h6>
									<h6 className="f-700 mb-4">Campus: Empowering Institutions to Shape Future-Ready Professionals</h6>
									<ul>
										<li>Academic institutions are the bedrock of future talent, and Khoj is
											dedicated to equipping them with the tools and resources needed to nurture excellence.
											The robust platform ensures that candidates gain visibility,
											enhance their skills, and access promising opportunities.</li>
									</ul>
									<button>
										<a href="/Services/Campus">
											Read More&nbsp;
											{/* <span className="icon-arrow-right2" /> */}
										</a>
									</button>
								</div>
							</div>

							<div className="tf-iconbox style-3 cl3 stc2 col-md-6 custom-works-card  text-center tf-iconbox-Rediscover">
								<div className="box-header">
									<div className="img1">
										<img src={img2} alt="img" className="mb-1" />
									</div>
								</div>
								<div className="box-content">
									<h6 className="box-title">
										{/* <Link to="/Blogsingle_v1">Recruiters</Link> */}
									</h6>
									<h6 className="f-700 mb-4">Corporate: Revolutionizing Talent Acquisition for Unparalleled Results </h6>

									<ul>
										<li>Khoj reimagines recruitment by bridging the gap between companies and workforce-ready candidates.
											Our streamlined solutions ensure efficiency, precision, and access to top-tier
											talent that aligns with your organizational needs.</li>
									</ul>
									<button>
										<a href="/Services/Corporate">
											Read More&nbsp;
											{/* <span className="icon-arrow-right2" /> */}
										</a>
									</button>
								</div>
							</div>

							<div className="tf-iconbox style-3 cl3 stc2 col-md-6 custom-works-card text-center tf-iconbox-Rediscover">
								<div className="box-header">
									<div className="img1">
										<img src={img3} alt="img" className="mb-1" />
									</div>
								</div>
								<div className="box-content ">
									<h6 className="box-title">
										{/* <Link to="/Blogsingle_v1">
											Companies
										</Link> */}
									</h6>
									<h6 className="f-700 mb-4">Talent: Elevate Your Career Prospects with KHOJ</h6>

									<ul>
										<li >Whether you are an emerging professional or an experienced candidate, Khoj is your
											trusted partner in navigating the dynamic job market. Our platform empowers individuals
											to unlock opportunities and shape fulfilling careers.
										</li>
									</ul>
									<button>
										<a href="/Services/Talent">
											Read More&nbsp;
											{/* <span className="icon-arrow-right2" /> */}
										</a>
									</button>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Iconbox3 />
				{/* <Testimonial data={dataTestimonials} /> */}
				{/* <Partner /> */}
				<Partner />
				{/* <section className="wd-banner-CTA">
					<div className="container">
						<div className="row">
							<div className="col-lg-12  wow fadeInUp">
								<div className="group-banner-CTA">
									<h3>Job Opportunities Are Always Open</h3>
									<p>
										Aenean porta, eros lacus congue lorem, sit amet mollis magna
										velit ac erat.
									</p>
									<div className="group-btn">
										<Link to={`/Jobs`}>
											<button className="tf-btn">Search Job</button>
										</Link>
										<button className="tf-btn">Find Candidates</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section> */}
				<Footer />
				<Gotop />
			</div>
		</>
	);
}

export default AboutUs;
